<mat-sidenav-container>
  <mat-sidenav #sidenav mode="over">
    <teams-nav></teams-nav>
  </mat-sidenav>
  <div id="content">
    <router-outlet></router-outlet>
  </div>
</mat-sidenav-container>
